import React from 'react';

export const BreadCrumbs = (props) => {
  return (<section className="row breadcrumbs visible-md-block visible-lg-block visible-xl-block">
    <div onClick={props.revertBottle} className={`col-sm-4 ${props.state === 'bottle' && 'active'}`}>
    CHOOSE BOTTLE{/*} &amp; SIZE*/}
    </div>
    <div onClick={props.customize} className={`col-sm-4 ${props.state === 'customize' && 'active'}`}>
    CUSTOMIZE
    </div>
    <div onClick={window.finalizeBottle} className={`col-sm-4 ${props.state === 'finalize' && 'active'}`}>
    FINALIZE
    </div>
    </section>);
};

export const Arrows = (props) => {
  return (
    <div className={`button-two-green-arrows ${props.className}`}>
    <svg className="svg-icon" viewBox="0 0 18.4 15.2">
    <polygon fill="#2B2B2B" className={props.focus ? "icon-focus" : ''} points="1.9,0 0,1.9 5.7,7.6 0,13.3 1.9,15.2 9.5,7.6   "></polygon>
    <polygon fill="#2B2B2B" className={props.focus ? "icon-focus" : ''} points="10.8,0 8.9,1.9 14.6,7.6 8.9,13.3 10.8,15.2 18.4,7.6   "></polygon>
    </svg>
    </div>
    );
};



// WEBPACK FOOTER //
// ./src/Extras.jsx